import * as React from 'react';
import Axios from 'axios';
import { ISimpleResponse } from '../../shared/common-dtos';

import './dtp-request.component.css'
import { localization } from 'src/App/shared/localization/localization';
import { DebuggerInstance } from 'src/App/shared/debugger';
import { EmailInput } from 'src/App/shared/components/email-input.component';
import { Markdown } from 'src/App/shared/localization/markdown-wrapper';
import { UserEmailStorageKey } from 'src/App/shared/constants';
import {TryGetValue} from "../../shared/local-storage";

export enum DtpRequestState {
    NotStarted,
    Sending,
    Completed,
    Failed
}

export interface IDtpRequest {
    email: string;
    userLang: string | null;
}

export interface IDtpRequestProps {
    logoId: string;
    apiUrl: string;
    onSendStarted(): void;
    onSendCompleted(result: boolean, email?: string, errorMsg?: string): void;
}

export interface IDtpRequestState {
    email: string;
    emailIsValid: boolean;
    reqState: DtpRequestState;
}

class DtpRequestComponent extends React.PureComponent<IDtpRequestProps,IDtpRequestState> {
    constructor(props: IDtpRequestProps) {
        super(props);

        let email = '';
        const emailValue = TryGetValue(UserEmailStorageKey);
        if(emailValue.hasValue) {
            email = emailValue.value as string;
        }

        this.state = {
            email,
            emailIsValid: false,
            reqState: DtpRequestState.NotStarted
        };
    }

    private async handleRequestReviewSubmit(): Promise<void> {

        DebuggerInstance.log('handleRequestReviewSubmit');

        const apiUrl: string = this.props.apiUrl + this.props.logoId + '/notify-dtp';
        const lang: string | null = localization.getLanguage();
        const data: IDtpRequest = {
            email: this.state.email,
            userLang: lang
        };

        try {
            this.props.onSendStarted();
            this.setState({
                reqState: DtpRequestState.Sending,
            });

            const result = await Axios.post<ISimpleResponse>(apiUrl, data);

            DebuggerInstance.log('dtp notify response');
            DebuggerInstance.log(result);

            if (result.data.success) {
                DebuggerInstance.log('dtp send completed successfully');

                this.setState({
                    reqState: DtpRequestState.Completed,
                });

                this.props.onSendCompleted(true, this.state.email);
            } else {
                this.setState({
                    reqState: DtpRequestState.Failed,
                });

                this.props.onSendCompleted(false, this.state.email, 'Failed to send DTP request!');
            }
        } catch (error) {
            DebuggerInstance.error(error);

            this.setState({
                reqState: DtpRequestState.Failed,
            });

            this.props.onSendCompleted(false, this.state.email, 'Failed to send DTP request!');
        }

    }

    private getSubmitButtonText(): string | JSX.Element {
        switch (this.state.reqState) {
            case DtpRequestState.NotStarted:
                return <Markdown text={localization.uploadLoc.dtpRequest.stateNotStarted} />;
            case DtpRequestState.Sending:
                return <Markdown text={localization.uploadLoc.dtpRequest.stateSending} />;
            case DtpRequestState.Failed:
                return <Markdown text={localization.uploadLoc.dtpRequest.stateFailed} />;
            case DtpRequestState.Completed:
                return <Markdown text={localization.uploadLoc.dtpRequest.stateCompleted} />;
            default:
                return '';
        }
    }

    public render() {
        const submitText = this.getSubmitButtonText();
        const disableControls: boolean = 
            this.state.reqState === DtpRequestState.Sending || this.state.reqState === DtpRequestState.Completed;

        return (
            <div className="dtp-request-root">
                <EmailInput
                    email={this.state.email}
                    onEmailChanged={(email, isValid) => {
                        this.setState({
                            email,
                            emailIsValid: isValid
                        });
                    }}
                    placeholder={localization.uploadLoc.dtpRequest.placeholder}
                    disabled={disableControls}
                />
                <button className="primary-button primary-style email-btn"
                    disabled={disableControls || !this.state.emailIsValid}
                    onClick={() => this.handleRequestReviewSubmit()}
                >{submitText}</button>
            </div>
        );
    }

}

export const DtpRequest = (props: IDtpRequestProps) => <DtpRequestComponent {...props} />



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-upload/dtp-request.component.tsx